
import Emitter from 'element-ui/src/mixins/emitter';
import { optionGroupProps } from './props';

export default {
  mixins: [Emitter],

  name: 'PtOptionGroup',

  componentName: 'PtOptionGroup',

  props: optionGroupProps,

  data: function data() {
    return {
      visible: true
    };
  },


  watch: {
    disabled: function disabled(val) {
      this.broadcast('PtOption', 'handleGroupDisabled', val);
    }
  },

  methods: {
    queryChange: function queryChange() {
      this.visible = this.$children && Array.isArray(this.$children) && this.$children.some(function (option) {
        return option.visible === true;
      });
    }
  },

  created: function created() {
    this.$on('queryChange', this.queryChange);
  },
  mounted: function mounted() {
    if (this.disabled) {
      this.broadcast('PtOption', 'handleGroupDisabled', this.disabled);
    }
  }
};